import React, { FC, useEffect } from 'react';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';
import { Header } from '../../header/Header';
//import { Footer } from '../../footer/Footer';
import { Modal } from '../../index';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { selectSchedule } from '../../../features/schedule/scheduleSelectors';
import { setScheduleEditorFullscreen } from '../../../features/schedule/scheduleSlice';

import './MainLayout.scss';

interface MainLayoutProps {
    children: React.ReactElement;
}

export const MainLayout: FC<MainLayoutProps> = (props) => {
    const { children } = props;
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { scheduleEditorFullscreen } = useAppSelector(selectSchedule);

    useEffect(() => {
        const tagMatch = matchPath<{ tag: string }>(location.pathname, {
            path: '/community/:communityId/tournament/:id/tags/:tag',
        });
        const onScheduleEditorRoute =
            tagMatch?.params?.tag === 'schedule' && Boolean(tagMatch);
        if (!onScheduleEditorRoute && scheduleEditorFullscreen) {
            dispatch(setScheduleEditorFullscreen(false));
        }
    }, [location.pathname, scheduleEditorFullscreen, dispatch]);

    return (
        <div
            className={classnames(
                'd-flex flex-column justify-content-between bg-grey vh-min-screen',
                { 'main-layout--schedule-fullscreen': scheduleEditorFullscreen }
            )}
        >
            {!scheduleEditorFullscreen && <Header />}
            <div
                className={classnames('main-layout__body', {
                    'main-layout__body--schedule-fullscreen': scheduleEditorFullscreen,
                })}
            >
                {children}
            </div>
            <Modal />
            {/* <Footer /> */}
        </div>
    );
};
